import { useTranslate } from '@/translations';
import { DamageExceptionModel, DamageExceptionType } from '@/types';
import { timeConverter } from '@/utils/helpers';
import { Descriptions, Divider } from 'antd';
import React, { FC } from 'react';

interface DamageDetailProps {
  detail: DamageExceptionModel;
  originalInfo: any;
}
export const DamageDetail: FC<DamageDetailProps> = ({
  detail,
  originalInfo,
}) => {
  const { t } = useTranslate();

  const rowItems = [
    {
      key: 0,
      label: t('vin').toUpperCase(),
      children: detail.vin,
    },
    {
      key: 1,
      label: 'Type',
      children: detail.typeDescription,
    },
    { key: 2, label: 'Created at', children: timeConverter(detail.createdAt) },
    {
      key: 3,
      label: 'Created by',
      children: detail.createdBy,
    },
    ...(detail.type === DamageExceptionType.FporDamage.toString()
      ? [
          { key: 4, label: 'FPOR Damage ID', children: originalInfo?.id },
          {
            key: 5,
            label: t('location'),
            children: originalInfo?.damageAreaDesc,
          },
          {
            key: 6,
            label: t('partComp'),
            children: originalInfo?.damagePartDesc,
          },
        ]
      : detail.type === DamageExceptionType.MaintenanceException.toString()
        ? [
            { key: 4, label: 'Exception ID', children: originalInfo?.id },
            {
              key: 5,
              label: 'Exception Reason',
              children: originalInfo?.failReason,
            },
          ]
        : []),
  ];

  return (
    <>
      <Divider>Damage & Exception Detail</Divider>
      <Descriptions
        className="light-content"
        bordered
        size="small"
        column={1}
        items={rowItems}
      />
    </>
  );
};
